<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Psicólogos</h1>
      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area" style="background-color:#bebebc">
            <div class="row">
              <div class="col-4">
                <input type="button" class="form-control" style="background-color:var(--verde-pj-100); color: var(--blanco-pj)" value="Nuevo Psicologo" @click="irAltaPsicologo" />
              </div>
            </div>
            <div class="row new-row">
              <table class="table table-striped table-light table-hover"
                     id="tablaPsicologos">
                <thead style="background-color:#004746">
                  <tr>
                    <th>Nombre</th>
                    <th>Cuenta de Usuario</th>
                    <th>Color Distintivo</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-for="psicologo in psicologos">
                    <td>{{psicologo.CuentaUsuario.Nombre}} {{psicologo.CuentaUsuario.ApellidoPaterno}} {{psicologo.CuentaUsuario.ApellidoMaterno}}</td>
                    <td>{{ psicologo.CuentaUsuario.Email }}</td>
                    <td><i class="fas fa-circle fa-3x" v-bind:style="{ color: psicologo.ColorDistintivo}" /></td>
                    <td>
                      <i class="fas fa-edit fa-lg" @click="editarPsicologo(psicologo.PsicologoId)" title="Editar Psicólogo" />
                      <i class="fas fa-ban fa-lg" @click="desactivarPsicologo(psicologo.PsicologoId)" title="Desactivar Psicólogo" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  export default {
    data() {
      return {
        psicologos: [],
        NumeroFilasPagina: 10
      }
    },
    components: {
    },
    methods: {
      irAltaPsicologo: function () {
        this.$router.push({
          name: "AltaDePsicologo" });
      },
      editarPsicologo: function (idPsicologo) {
        this.$router.push({
          name: "AltaDePsicologo",
          params: { idPsicologo: idPsicologo }
        });
      },
      buscarPsicologos: function () {
        var peticion = {
          "esPrueba": false
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.ObtenerPsicologos, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.psicologos = response.data.Psicologos

            this.$nextTick(() => {
              PaginarTabla('tablaPsicologos', this.NumeroFilasPagina)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      desactivarPsicologo: function (idPsicologo) {
        var peticion = {
          "esPrueba": false,
          "PsicologoId": idPsicologo
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.DesactivarPsicologo, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response.data)
            this.buscarPsicologos();
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null)

          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }

    }, mounted: function mounted() {
      this.buscarPsicologos();
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  .new-row {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SIPSIC/Administracion/Psicologos/Psicologos.vue